export enum HospitalActionTypes {
  GET_FORMS_REPORT = "@@HOSPITAL/GET_FORMS_REPORT",
  GET_FORMS_REPORT_SUCCESS = "@@HOSPITAL/GET_FORMS_REPORT_SUCCESS",
  GET_FORMS_REPORT_FAILURE = "@@HOSPITAL/GET_FORMS_REPORT_FAILURE",

  GET_SESSIONS_REPORT = "@@HOSPITAL/GET_SESSIONS_REPORT",
  GET_SESSIONS_REPORT_SUCCESS = "@@HOSPITAL/GET_SESSIONS_REPORT_SUCCESS",
  GET_SESSIONS_REPORT_FAILURE = "@@HOSPITAL/GET_SESSIONS_REPORT_FAILURE",

  GET_SENSORDS_DATA_REPORT = "@@HOSPITAL/GET_SENSORDS_DATA_REPORT",
  GET_SENSORDS_DATA_REPORT_SUCCESS = "@@HOSPITAL/GET_SENSORDS_DATA_REPORT_SUCCESS",
  GET_SENSORDS_DATA_REPORT_FAILURE = "@@HOSPITAL/GET_SENSORDS_DATA_REPORT_FAILURE",

  GET_DETAILED_SENSORDS_DATA_REPORT = "@@HOSPITAL/GET_DETAILED_SENSORDS_DATA_REPORT",
  GET_DETAILED_SENSORDS_DATA_REPORT_SUCCESS = "@@HOSPITAL/GET_DETAILED_SENSORDS_DATA_REPORT_SUCCESS",
  GET_DETAILED_SENSORDS_DATA_REPORT_FAILURE = "@@HOSPITAL/GET_DETAILED_SENSORDS_DATA_REPORT_FAILURE",

  GET_DETAILED_UNFILTERED_SENSORDS_DATA_REPORT = "@@HOSPITAL/GET_DETAILED_UNFILTERED_SENSORDS_DATA_REPORT",
  GET_DETAILED_UNFILTERED_SENSORDS_DATA_REPORT_SUCCESS = "@@HOSPITAL/GET_DETAILED_UNFILTERED_SENSORDS_DATA_REPORT_SUCCESS",
  GET_DETAILED_UNFILTERED_SENSORDS_DATA_REPORT_FAILURE = "@@HOSPITAL/GET_DETAILED_UNFILTERED_SENSORDS_DATA_REPORT_FAILURE",

  GET_COMPLIANCE_DATA_REPORT = "@@HOSPITAL/GET_COMPLIANCE_DATA_REPORT",
  GET_COMPLIANCE_DATA_REPORT_SUCCESS = "@@HOSPITAL/GET_COMPLIANCE_DATA_REPORT_SUCCESS",
  GET_COMPLIANCE_DATA_REPORT_FAILURE = "@@HOSPITAL/GET_COMPLIANCE_DATA_REPORT_FAILURE",
}
